import { render, staticRenderFns } from "./CollaborationWordDetail.vue?vue&type=template&id=05441172&scoped=true"
import script from "./CollaborationWordDetail.vue?vue&type=script&lang=js"
export * from "./CollaborationWordDetail.vue?vue&type=script&lang=js"
import style0 from "./CollaborationWordDetail.vue?vue&type=style&index=0&id=05441172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05441172",
  null
  
)

export default component.exports